import {Routes} from '@angular/router';
import {canActivateGuard} from '../../../guards/can-activate-guard';
import {IndexComponent as EmployeeIndexComponent} from './index/index.component';
import {PERMISSION} from '@generated-backend-types';
import {EditComponent as EmployeeEditComponent} from './edit/edit.component';
import {TimeTrackingEmployeeService} from '../../../services/api/time-tracking/time-tracking-employee.service';

export const routes: Routes = [
  {
    path: '',
    component: EmployeeIndexComponent,
    canActivate: [canActivateGuard],
    data: {
      allPermissionsNeeded: [PERMISSION.TIMETRACKING_TIMETRACKINGEMPLOYEE_TIMETRACKINGEMPLOYEE_READ_ALL],
      breadcrumb: [
        {
          label: 'authenticated.time_tracking.employees.index.breadcrumb',
          translate: true,
          route: '/time-tracking/employees',
        },
      ]
    }
  },
  {
    path: ':id',
    component: EmployeeEditComponent,
    canActivate: [canActivateGuard],
    resolve: {
      employee: TimeTrackingEmployeeService,
    },
    data: {
      allPermissionsNeeded: [PERMISSION.TIMETRACKING_TIMETRACKINGEMPLOYEE_TIMETRACKINGEMPLOYEE_UPDATE_ALL],
      breadcrumb: [
        {
          label: 'authenticated.time_tracking.employees.index.breadcrumb',
          translate: true,
          route: '/time-tracking/employees',
        },
        {dynamic: true, dataKey: 'employee.user.name', route: '/time-tracking/employees/:id'},
        {label: 'authenticated.time_tracking.employees.edit.breadcrumb', translate: true,},
      ]
    }
  },
];
